import React, {useEffect, useState} from 'react';
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import {useDispatch} from "react-redux";
import {finishLoading, startLoading} from "../../_store/_actions/uiActions";
import HttpClient from "../../_services/httpClient";
import { GrNext } from 'react-icons/gr';

const ContractInfo = ({contractFolio}) => {

    const dispatch = useDispatch();
    const [contractInfo, setContractInfo] = useState({});
    const [value, setValue] = useState('');

    const getData = (url) => {
        return new Promise((resolve, eject) => {
            dispatch(startLoading());
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const handleInputChange = ({ target }) => {
        setValue(target.value);
    }

    const getContract = (folio) => {
        if (folio) {
            getData(`/reefcontract/${folio}`).then((response) => {
                if (response.status === 200) {
                    setContractInfo(response.data);
                }
            })
        }
    }

    const handleContractCheck = (e) => {
        e.preventDefault();
        getContract(value);
    }

    useEffect(() => {
        setValue(contractFolio)
        getContract(contractFolio);
    }, [contractFolio]);

    return (
        <>
            <label htmlFor="profile-form-contract">Contract Num.:</label>
            <div className="input-group mb-3">

                <input type="text"
                       id="value"
                       name="value"
                       value={value}
                       onChange={handleInputChange}
                       className="form-control not-dark"
                />
                <div className="input-group-append">
                    <button className="button button-3d button-black nomargin" type="button"
                            id="button-addon2"
                            onClick={handleContractCheck}
                    >CHECK
                    </button>
                </div>
            </div>

            <Accordion defaultActiveKey="0">
                <Card className="nomargin nopadding">
                    <Card.Header className="nomargin nopadding">
                        <Accordion.Toggle as={Card.Header} variant="link" eventKey="1">
                            <GrNext /> Reef Contract Detail
                        </Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="1" >
                        <Card.Body>
                            <div className="contract-info">
                                <h4>Contract information</h4>

                                <div className="col_full nomargin">
                                    <label>Membership type: <p>{contractInfo.membresia}</p></label>
                                </div>
                                <div className="col_full nomargin">
                                    <label>membership partner 1: <p>{contractInfo.nombre1}</p></label>
                                </div>

                                <div className="col_full nomargin">
                                    <label>membership partner 2: <p>{contractInfo.nombre2}</p></label>
                                </div>

                                <div className="col_full nomargin">
                                    <label>membership status: <p>{contractInfo.statusContrato1}</p></label>
                                </div>
                            </div>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        </>
    );
};

export default ContractInfo;
